import { render, staticRenderFns } from "./UpdatesTable.vue?vue&type=template&id=6ba93f8a&scoped=true"
import script from "./UpdatesTable.vue?vue&type=script&lang=js"
export * from "./UpdatesTable.vue?vue&type=script&lang=js"
import style0 from "./UpdatesTable.vue?vue&type=style&index=0&id=6ba93f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba93f8a",
  null
  
)

export default component.exports